import React, { useState, useEffect } from 'react';

import Script from 'next/script';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/user/selectors';

import { config } from 'common/config';

export const Pendo = () => {
    const [isReady, setIsReady] = useState(false);
    const user = useSelector(selectUser);

    useEffect(() => {
      if (isReady && user && !user.emailAddress?.includes('e2e')) {
        const company = {
          companyName: user.Company?.name || '',
          companyCode: user.Company?.code || '',
          companyId: user.companyId!,
        }
        window.pendo?.initialize({
          visitor: {
            id: user.id.toString(),
            email: user.emailAddress!,
            role: user.roles?.map((role) => role.name).join(', ') || '',
            ...company
          },
          account: {
            id: user.Company?.code || '',
            ...company
          }
        });
      }
    }, [user, isReady]);

    if(!config.pendoKey) {
      return null;
    }

    return (
      <Script
        async
        id="pendo"
        src={`https://cdn.pendo.io/agent/static/${config.pendoKey}/pendo.js`}
        onReady={() => setIsReady(true)}
      />
    )
}
